const React = require('react');
const noop = require('mn-utils/noop');

const withState = require('../../../../../../utils/withState');

const Loading = require('../../../../Loading');
const {BtnBack} = require('../../../Buttons/');

const Button = require('../../../../Button/Accept');

const {PRIMARY_DATA, SECONDARY_DATA, FEES_RETAILER, FEES_CUSTOMER, CHARGEBACK_DATA} = require('./constants');

const TrxDetailsRow = require('./components/TrxDetailsRow');
const TrxDetailsCol = require('./components/TrxDetailsCol');
const TrxDetailsItem = require('./components/TrxDetailsItem');

const openChargebackWindow = require('./utils/openChargebackWindow');
const openResetWindow = require('./utils/openResetWindow');
const {apiAdminTrxChargebackGet, apiAdminLiquidpoolFailedListGit} = require("../../../../../../api/admin/transactions");
const {USER_TYPE_PARTNER} = require("../../../../../../constants");


module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    loading: true
  };

  const updateData = () => {
    const req = self.props.requrest;

    if (!req) return;

    setState({loading: true});

    const id = self.props.emitter.getValue()
    const failedLiquidpoolList = apiAdminLiquidpoolFailedListGit()
        .then(({list = []}) => {
          return list.map((el = {}) => {
            return (((el.task || {}).task || [])[0] || {}).track_id;
          }).filter((el) => el);
        });
    const trxChargeback = apiAdminTrxChargebackGet({id});
    const trxData = req({id});

    return Promise.all([trxData, trxChargeback, failedLiquidpoolList])
      .then((res) => {
        const [
          data,
          chargeback,
          failedLiquidpoolList = []
        ] = res;

        setState({
          data,
          chargeback,
          needReset: failedLiquidpoolList.includes(data.id),
          loading: false
        });
      }).catch(() => {});
  }

  onMount(() => {
    const req = self.props.requrest;

    if (!req) {
      setState({loading: false});
      return;
    }

    updateData();
  });

  return (state, props) => {
    const {data, chargeback, needReset, loading} = state;

    if (loading) return <Loading />;

    const userIsPartner = (data.account || {}).role === USER_TYPE_PARTNER;

    const showRetailerFees = (
      !!Number((data['retailer_fees'] || {}).total_amount)
      || !!Number((data['retailer_fees'] || {}).tax)
      || !!Number((data['retailer_fees'] || {}).rolling_reserve)
    );

    return (
      <>
        <div className="layoutRow jcSB aiC">
          <div className="layoutRow aiC">
            <div className="mr20">
              <BtnBack
                onClick={props.emitter
                  ? () => props.emitter.emit('')
                  : noop
                }
              />
            </div>
            <div className="mr20">
              <h2 className="f16 lh23 fw7 m0 p0">
                Payment Details
              </h2>
            </div>
          </div>
          {/*<div className="layoutRow">*/}
          {/*  <div className="ml10">*/}
          {/*    <PDFBtnPrint />*/}
          {/*  </div>*/}
          {/*  <div className="ml10">*/}
          {/*    <PDFBtnDownload />*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
        <TrxDetailsRow className="mt20">
          {PRIMARY_DATA.map((el, id) => (
            <TrxDetailsCol key={id}>
              <TrxDetailsItem
                {...el}
                data={data}
              />
            </TrxDetailsCol>
          ))}
        </TrxDetailsRow>
        <div className="w h1 mt32 bg2C2D30" />
        <TrxDetailsRow className="mt9">
          {SECONDARY_DATA.map((el, id) => {
            if (el.displayCheck && !el.displayCheck(data)) return true;

            return (
              <TrxDetailsCol key={id}>
                <TrxDetailsItem
                  {...el}
                  data={data}
                />
              </TrxDetailsCol>
            )
          })}
        </TrxDetailsRow>
        {showRetailerFees
          && (
            <>
              <div className="w h1 mt32 bg2C2D30" />
              <div className="mt29">
                <h3 className="f16 lh24 fw7 p0 m0">Retailer Fees</h3>
              </div>
              <TrxDetailsRow className="mt9">
                {FEES_RETAILER.map((el, id) => (
                  <TrxDetailsCol key={id}>
                    <TrxDetailsItem
                      {...el}
                      data={data}
                    />
                  </TrxDetailsCol>
                ))}
              </TrxDetailsRow>
            </>
          )
        }
        {!!Number((data['customer_fees'] || {}).total_amount) && (
          <>
            <div className="w h1 mt32 bg2C2D30" />
            <div className="mt29">
              <h3 className="f16 lh24 fw7 p0 m0">Customer Fees</h3>
            </div>
            <TrxDetailsRow className="mt9">
              {FEES_CUSTOMER.map((el, id) => (
                <TrxDetailsCol key={id}>
                  <TrxDetailsItem
                    {...el}
                    data={data}
                  />
                </TrxDetailsCol>
              ))}
            </TrxDetailsRow>
          </>
        )}
        {!userIsPartner && data.lifeflow === 'accepted' && !chargeback.id && (
          <div className="mt30">
            <Button onClick={() => openChargebackWindow(data, updateData)}>
              Chargeback
            </Button>
          </div>
        )}
        {needReset && (
          <div className="mt30">
            <Button onClick={() => openResetWindow(data, updateData)}>
              Reset
            </Button>
          </div>
        )}
        {chargeback.id && (
          <>
            <div className="w h1 mt32 bg2C2D30" />
            <h3 className="mt38 f18 lh23 fw7 m0 p0">
              Chargeback Data
            </h3>
            <TrxDetailsRow className="mt9">
              {CHARGEBACK_DATA.map((el, id) => (
                <TrxDetailsCol key={id}>
                  <TrxDetailsItem
                    {...el}
                    data={chargeback}
                  />
                </TrxDetailsCol>
              ))}
            </TrxDetailsRow>
          </>
        )}
      </>
    )
  }
});
